import type { SelectValueType, SelectOptionType } from '../../type';

const getOptionLabel = (val: string, options?: SelectOptionType[], tempLabel?: string): string => {
  const opt = options?.find((opt) => opt.value === val);
  if (!opt) return tempLabel ?? val;

  return opt.variants?.[0]?.themePageInfo?.label ?? opt.label;
};

const formatLabels = (labels: string[]): string => {
  if (labels.length === 0) return 'Add value';
  if (labels.length === 1) return labels[0];
  if (labels.length === 2) return `${labels[0]} or ${labels[1]}`;

  return `${labels.slice(0, -1).join(', ')}, or ${labels.at(-1)}`;
};

export const getSelectLabel = (
  selected?: SelectValueType,
  options?: SelectOptionType[],
  tempLabel?: string,
): string => {
  if (!selected) return 'Add value';

  const values = Array.isArray(selected) ? selected : [selected];
  const labels = values.map((v) => getOptionLabel(v, options, tempLabel));

  return formatLabels(labels);
};
